module.exports = __webpack_public_path__ + "static/media/avatar_wolf.f589438b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_wolf.png
// module id = 402
// module chunks = 0